<template>
  <div>
    <modal-component
      title="Formulário MTSE"
      :value="show && formulario !== null"
      @input="onCloseModal"
      :overlay-closes="false"
    >
      <div class="modal-content">
        <div class="form-steps-vue">
          <div class="steps">
            <div class="tabs">
              <h3 class="tab tab-0" @click="onTabClick">Cap. Máx. de Op. Diária</h3>
              <h3 class="tab tab-1" @click="onTabClick">DETALHES DO TERRRENO E PROJETO</h3>
              <h3 class="tab tab-2" @click="onTabClick">ÁGUA DE ABASTEC. E INST. INDUS.</h3>
              <h3 class="tab tab-3" @click="onTabClick">MÁQUINAS E EQUIPAMENTOS</h3>
              <h3 class="tab tab-4" @click="onTabClick">MATÉRIAS-PRIMAS E PRODUTOS</h3>
              <h3 class="tab tab-5" @click="onTabClick">Outras informações</h3>
            </div>
            <div class="content" v-if="show && formulario !== null">
              <div class="container content-0">
                <div class="row">
                  <div class="col-md-12">
                    <h3>Capacidade Máxima de Operação Diária</h3>
                  </div>
                </div>
                <capacidade-maxima-operacao-component
                  :value="formulario.capacidade_maxima_op_list"
                  :categorias="categorias"
                  :unidades-medida="unidadesMedida"
                  @change="onChangeCategorias"
                ></capacidade-maxima-operacao-component>
              </div>
              <div class="container content-1">
                <div class="row">
                  <div class="col-md-12">
                    <h3>DETALHES DO TERRENO</h3>
                  </div>
                </div>
                <div class="row d-flex align-items-end">
                  <div class="col-md-3">
                    <div class="form-group required">
                      <label for="area_total_terreno">Área total do terreno (m²)</label>
                      <input
                        type="text"
                        class="form-control"
                        name="area_total_terreno"
                        id="area_total_terreno"
                        v-model="formulario.terreno.area_total_terreno"
                        v-money="{
                          decimal: ',',
                          thousands: '.',
                          prefix: '',
                          suffix: ' m²',
                          precision: 2
                        }"
                      />
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="form-group required">
                      <label for="area_a_construir">Área a ser construída (m²)</label>
                      <input
                        type="text"
                        class="form-control"
                        name="area_a_construir"
                        id="area_a_construir"
                        v-model="formulario.terreno.area_a_construir"
                        v-money="{
                          decimal: ',',
                          thousands: '.',
                          prefix: '',
                          suffix: ' m²',
                          precision: 2
                        }"
                      />
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="form-group required">
                      <label for="area_util">Área útil (m²)</label>
                      <input
                        type="text"
                        class="form-control"
                        name="area_util"
                        id="area_util"
                        v-model="formulario.terreno.area_util"
                        v-money="{
                          decimal: ',',
                          thousands: '.',
                          prefix: '',
                          suffix: ' m²',
                          precision: 2
                        }"
                      />
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="form-group required">
                      <label for="recuo_alinhamento_rua">Recuo do alinhamento da rua (m)</label>
                      <input
                        type="text"
                        class="form-control"
                        name="recuo_alinhamento_rua"
                        id="recuo_alinhamento_rua"
                        v-model="formulario.terreno.recuo_alinhamento_rua"
                        v-money="{
                          decimal: ',',
                          thousands: '.',
                          prefix: '',
                          suffix: ' m',
                          precision: 2
                        }"
                      />
                    </div>
                  </div>
                </div>
                <div class="row d-flex align-items-end">
                  <div class="col-md-2">
                    <div class="form-group required">
                      <label
                        for="delimitacao_perimetro_industrial"
                      >Delimitação do perímetro industrial</label>
                      <div :title="formulario.terreno.delimitacao_perimetro_industrial">
                        <input
                          type="text"
                          class="form-control"
                          name="delimitacao_perimetro_industrial"
                          id="delimitacao_perimetro_industrial"
                          v-model="
                            formulario.terreno.delimitacao_perimetro_industrial
                          "
                        />
                      </div>
                    </div>
                  </div>
                  <div class="col-md-5">
                    <div class="form-group required">
                      <label for="descricao_perfil_terreno">Descrição ou perfil do terreno</label>
                      <div :title="formulario.terreno.descricao_perfil_terreno">
                        <input
                          type="text"
                          class="form-control"
                          name="descricao_perfil_terreno"
                          id="descricao_perfil_terreno"
                          placeholder="Ex: plano, com declive, irregular, etc."
                          v-model="formulario.terreno.descricao_perfil_terreno"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="col-md-5">
                    <div class="form-group required">
                      <label
                        for="facilidade_escoamento_agua"
                      >Facilidade de escoamento das águas pluviais</label>
                      <div :title="formulario.terreno.facilidade_escoamento_agua">
                        <input
                          type="text"
                          class="form-control"
                          name="facilidade_escoamento_agua"
                          id="facilidade_escoamento_agua"
                          v-model="formulario.terreno.facilidade_escoamento_agua"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row d-flex align-items-end">
                  <div class="col-md-5">
                    <div class="form-group required">
                      <label
                        for="destino_aguas_residuais"
                      >Destino das águas residuais e Rede de esgoto</label>
                      <div :title="formulario.terreno.destino_aguas_residuais">
                        <input
                          type="text"
                          class="form-control"
                          name="destino_aguas_residuais"
                          id="destino_aguas_residuais"
                          v-model="formulario.terreno.destino_aguas_residuais"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="col-md-5">
                    <div class="form-group required">
                      <label for="fontes_mau_cheiro">Fontes de mau cheiro</label>
                      <div :title="formulario.terreno.fontes_mau_cheiro">
                        <input
                          type="text"
                          class="form-control"
                          name="fontes_mau_cheiro"
                          id="fontes_mau_cheiro"
                          v-model="formulario.terreno.fontes_mau_cheiro"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="col-md-2">
                    <div class="form-group required">
                      <label for="tipo_localizacao">Tipo de Localização:</label>
                      <select
                        name="tipo_localizacao"
                        id="tipo_localizacao"
                        class="form-control"
                        v-model="formulario.terreno.tipo_localizacao"
                      >
                        <option value>Selecione</option>
                        <option value="RURAL">Rural</option>
                        <option value="URBANA">Urbana</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12">
                    <h3>
                      TIPO DE PAVIMENTAÇÃO EXTERNA(área de transito de veículos
                      e pessoas)
                    </h3>
                    <div class="form-group required">
                      <textarea
                        class="form-control"
                        name="tipo_pavimentacao_externa"
                        v-model="formulario.terreno.tipo_pavimentacao_externa"
                      ></textarea>
                    </div>
                  </div>
                </div>
              </div>
              <div class="container content-2">
                <div class="row">
                  <div class="col-md-12">
                    <h3>ÁGUA DE ABASTECIMENTO</h3>
                  </div>
                </div>
                <add-mtse-item-table-component
                  :value="formulario.agua_abastecimento"
                  id-field="cod_agua_abastecimento"
                  name="agua_abastecimento"
                  @change="ev => (formulario.agua_abastecimento = ev)"
                >
                  <div class="row d-flex align-items-end form-fields">
                    <div class="col-md-4">
                      <div class="form-group">
                        <label for="fonte_produtora">Fonte produtora</label>
                        <select name="fonte_produtora" id="fonte_produtora" class="form-control">
                          <option value>Selecione</option>
                          <option value="POÇO">Poço</option>
                          <option value="REDE PÚBLICA">Rede pública</option>
                          <option value="ÁGUA DE SUPERFÍCIE">Água de superfície</option>
                        </select>
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="form-group">
                        <label for="vazao">Vazão (m³/hora)</label>
                        <input
                          type="text"
                          class="form-control"
                          name="vazao"
                          id="vazao"
                          v-money="{
                            decimal: ',',
                            thousands: '.',
                            prefix: '',
                            suffix: ' m³/h',
                            precision: 6
                          }"
                        />
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="form-group">
                        <label for="capacidade_reservatorio">Capacidade do reservatório (m³)</label>
                        <input
                          type="text"
                          class="form-control"
                          name="capacidade_reservatorio"
                          id="capacidade_reservatorio"
                          v-money="{
                            decimal: ',',
                            thousands: '.',
                            prefix: '',
                            suffix: ' m³',
                            precision: 4
                          }"
                        />
                      </div>
                    </div>
                  </div>
                </add-mtse-item-table-component>
                <div class="row">
                  <div class="col-md-12">
                    <h3>INSTALAÇÕES INDUSTRIAIS</h3>
                  </div>
                </div>
                <add-mtse-item-table-component
                  :value="formulario.instalacoes_industriais"
                  id-field="cod_instalacao_industrial"
                  name="instalacoes_industriais"
                  @change="ev => (formulario.instalacoes_industriais = ev)"
                  ref="addItemTableInstalacoesIndustriais"
                  :required="false"
                >
                  <div class="form-fields">
                    <div class="row d-flex align-items-end">
                      <div class="col-md-3">
                        <div class="form-group">
                          <label for="instalacao_industrial">Instalação industrial</label>
                          <select
                            name="instalacao_industrial"
                            id="instalacao_industrial"
                            class="form-control"
                            :disabled="instalacoes.length === 0"
                          >
                            <option value>Selecione</option>
                            <option
                              v-for="(instalacao, index) of instalacoes"
                              :key="index"
                              :value="instalacao.cod_instalacao_area"
                            >{{ instalacao.instalacao }}</option>
                          </select>
                        </div>
                      </div>
                      <div class="col-md-3">
                        <div class="form-group">
                          <label for="temperatura_op">Temp. de Operação (°C)</label>
                          <input
                            type="text"
                            class="form-control"
                            name="temperatura_op"
                            id="temperatura_op"
                            v-model="temperatura"
                            :disabled="instalacoes.length === 0"
                          />
                        </div>
                      </div>
                      <div class="col-md-3">
                        <div class="form-group">
                          <label for="pe_direito">Pé-direito (m)</label>
                          <input
                            type="text"
                            class="form-control"
                            name="pe_direito"
                            id="pe_direito"
                            v-money="{
                              decimal: ',',
                              thousands: '.',
                              prefix: '',
                              suffix: ' m',
                              precision: 2
                            }"
                            :disabled="instalacoes.length === 0"
                          />
                        </div>
                      </div>
                      <div class="col-md-3">
                        <div class="form-group">
                          <label for="material_piso">Material e declividade do piso</label>
                          <input
                            type="text"
                            class="form-control"
                            name="material_piso"
                            id="material_piso"
                            :disabled="instalacoes.length === 0"
                          />
                        </div>
                      </div>
                    </div>
                    <div class="row d-flex align-items-end">
                      <div class="col-md-3">
                        <div class="form-group">
                          <label for="revestimento_paredes">Revestimento das paredes</label>
                          <input
                            type="text"
                            class="form-control"
                            name="revestimento_paredes"
                            id="revestimento_paredes"
                            :disabled="instalacoes.length === 0"
                          />
                        </div>
                      </div>
                      <div class="col-md-3">
                        <div class="form-group">
                          <label for="material_pje">Material das portas, janelas, esquadrias</label>
                          <input
                            type="text"
                            class="form-control"
                            name="material_pje"
                            id="material_pje"
                            :disabled="instalacoes.length === 0"
                          />
                        </div>
                      </div>
                      <div class="col-md-3">
                        <div class="form-group">
                          <label for="material_forro">Material do Forro</label>
                          <input
                            type="text"
                            class="form-control"
                            name="material_forro"
                            id="material_forro"
                            :disabled="instalacoes.length === 0"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </add-mtse-item-table-component>
              </div>
              <div class="container content-3">
                <div class="row">
                  <div class="col-md-12">
                    <h3>Máquinas e Equipamentos</h3>
                  </div>
                </div>
                <add-mtse-item-table-component
                  :value="formulario.maquinas_equipamentos"
                  id-field="cod_maquina_equipamento"
                  name="maquinas_equipamentos"
                  @change="ev => (formulario.maquinas_equipamentos = ev)"
                >
                  <div class="row d-flex align-items-end form-fields">
                    <div class="col-md-3">
                      <div class="form-group">
                        <label for="maquina_equipamento">Máquina e Equipamento</label>
                        <input
                          type="text"
                          class="form-control"
                          name="maquina_equipamento"
                          id="maquina_equipamento"
                        />
                      </div>
                    </div>
                    <div class="col-md-3">
                      <div class="form-group">
                        <label for="quantidade_equipamentos">Quantidade</label>
                        <input
                          type="text"
                          class="form-control numeric"
                          name="quantidade"
                          id="quantidade_equipamentos"
                        />
                      </div>
                    </div>
                    <div class="col-md-3">
                      <div class="form-group">
                        <label for="capacidade_equipamentos">Capacidade</label>
                        <input
                          type="text"
                          class="form-control numeric"
                          name="capacidade_equipamentos"
                          id="capacidade_equipamentos"
                          data-not-required="true"
                          data-not-apply="true"
                        />
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="form-group">
                        <label for="unidade_medida">Unidade Medida</label>
                        <input
                          type="text"
                          class="form-control"
                          name="unidade_medida"
                          id="unidade_medida"
                          data-not-required="true"
                          data-not-apply="true"
                        />
                      </div>
                    </div>
                  </div>
                </add-mtse-item-table-component>
              </div>
              <div class="container content-4">
                <div class="row">
                  <div class="col-md-12">
                    <h3>MATÉRIAS-PRIMAS</h3>
                  </div>
                </div>
                <add-mtse-item-table-component
                  :value="formulario.materias_primas"
                  id-field="cod_materia_prima"
                  name="materias_primas"
                  @change="ev => (formulario.materias_primas = ev)"
                >
                  <div class="row d-flex align-items-end form-fields">
                    <div class="col-md-4">
                      <div class="form-group">
                        <label for="tipo_materia_prima">Tipos de matérias-primas</label>
                        <input
                          type="text"
                          class="form-control"
                          name="tipo_materia_prima"
                          id="tipo_materia_prima"
                        />
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="form-group">
                        <label for="meios_transporte">Meios de transporte</label>
                        <input
                          type="text"
                          class="form-control"
                          name="meios_transporte"
                          id="meios_transporte"
                        />
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="form-group">
                        <label for="procedencia">Procedência</label>
                        <input type="text" class="form-control" name="procedencia" id="procedencia" />
                      </div>
                    </div>
                  </div>
                </add-mtse-item-table-component>
                <div class="row">
                  <div class="col-md-12">
                    <h3>
                      PRODUTOS QUE PRETENDE FABRICAR (Conforme Nomenclatura
                      padronizada DIPOA)
                    </h3>
                  </div>
                </div>
                <add-mtse-item-table-component
                  :value="formulario.produtos_fabricar"
                  id-field="cod_produto_fabricar"
                  name="produtos_fabricar"
                  @change="ev => (formulario.produtos_fabricar = ev)"
                >
                  <div class="form-fields">
                    <div class="row d-flex align-items-end">
                      <div class="col-md-3">
                        <div class="form-group">
                          <label for="cod_area">Área</label>
                          <select
                            name="cod_area"
                            id="cod_area"
                            class="form-control readonly"
                            v-model="formulario.area.cod_area"
                            :readonly="true"
                          >
                            <option value>Selecione</option>
                            <option
                              v-for="(area, index) of areas"
                              :key="index"
                              :value="area.cod_area"
                            >{{ area.nome }}</option>
                          </select>
                        </div>
                      </div>
                      <div class="col-md-3">
                        <div class="form-group">
                          <label for="categoria">Categoria</label>
                          <select name="cod_categoria" id="categoria" class="form-control">
                            <option value>Selecione</option>
                            <option
                              v-for="(categoria, index) of allowedCategories"
                              :key="index"
                              :value="categoria.cod_categoria"
                            >{{ categoria.nome }}</option>
                          </select>
                        </div>
                      </div>
                      <div class="col-md-3">
                        <div class="form-group">
                          <label for="produto_padronizado">Produto padronizado</label>
                          <input
                            type="text"
                            class="form-control"
                            name="produto_padronizado"
                            id="produto_padronizado"
                          />
                        </div>
                      </div>
                      <div class="col-md-3">
                        <div class="form-group">
                          <label for="forma_conservacao">Forma de Conservação</label>
                          <select name="forma_conservacao" class="form-control" id="forma_conservacao">
                            <option value="">Selecione</option>
                            <option value="RESFRIADO">Resfriado</option>
                            <option value="CONGELADO">Congelado</option>
                            <option value="SEM_REFRIGERACAO">Sem refrigeração</option>
                            <option value="USO_DO_GELO">Uso do gelo</option>
                          </select>
                        </div>
                      </div>
                    </div>
                    <div class="row d-flex align-items-end">
                      <div class="col-md-3">
                        <div class="form-group">
                          <label for="finalidade">Finalidade</label>
                          <select name="finalidade" class="form-control" id="finalidade">
                            <option value="">Selecione</option>
                            <option value="INDUSTRIAL">Industrial</option>
                            <option value="COMERCIAL">Comercial</option>
                            <option value="INDUSTRIAL_COMERCIAL">Industrial e comercial</option>
                          </select>
                        </div>
                      </div>
                      <div class="col-md-3">
                        <div class="form-group">
                          <label for="quantidade_diaria">Quantidade diária</label>
                          <input
                            type="text"
                            class="form-control numeric"
                            name="quantidade_diaria"
                            id="quantidade_diaria"
                          />
                        </div>
                      </div>
                      <div class="col-md-3">
                        <div class="form-group">
                          <label for="unidade">Unidade de medida</label>
                          <select name="unidade" class="form-control" id="unidade">
                            <option value>Selecione</option>
                            <option
                              v-for="(item, indexUnMedida) of unidadesMedida"
                              :key="indexUnMedida"
                              :value="item.cod_unidade_medida"
                            >{{ item.descricao_unidade_medida }}</option>
                          </select>
                        </div>
                      </div>
                    </div>
                  </div>
                </add-mtse-item-table-component>
              </div>
              <div class="container content-5">
                <div class="row">
                  <div class="col-md-12">
                    <h3>Funcionários</h3>
                  </div>
                </div>
                <add-mtse-item-table-component
                  :value="formulario.funcionarios"
                  id-field="cod_funcionario_mtse"
                  name="funcionarios"
                  @change="ev => (formulario.funcionarios = ev)"
                >
                  <div class="row d-flex align-items-end form-fields">
                    <div class="col-md-4">
                      <div class="form-group">
                        <label for="turno_producao">Turno de produção/abate</label>
                        <select name="turno_producao" class="form-control" id="turno_producao">
                          <option value>Selecione</option>
                          <option value="MATUTINO">Matutino</option>
                          <option value="VESPERTINO">Vespertino</option>
                          <option value="NOTURNO">Noturno</option>
                        </select>
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="form-group">
                        <label for="sexo">Sexo</label>
                        <select name="sexo" class="form-control" id="sexo">
                          <option value>Selecione</option>
                          <option value="M">Masculino</option>
                          <option value="F">Feminino</option>
                        </select>
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="form-group">
                        <label for="quantidade_funcionarios">Quantidade</label>
                        <input
                          type="text"
                          name="quantidade"
                          class="form-control numeric"
                          id="quantidade_funcionarios"
                        />
                      </div>
                    </div>
                  </div>
                </add-mtse-item-table-component>
                <div class="row">
                  <div class="col-md-12">
                    <h3>PROCESSO DE ABATE/PRODUÇÃO (Quando aplicável)</h3>
                    <div class="form-group">
                      <textarea
                        class="form-control"
                        name="processo_abate"
                        v-model="formulario.processo_abate"
                      ></textarea>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12">
                    <h3>BARREIRAS FÍSICAS CONTRA PRAGAS</h3>
                    <div class="form-group required">
                      <textarea
                        class="form-control"
                        name="barreiras_fisicas"
                        v-model="formulario.barreiras_fisicas"
                      ></textarea>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12">
                    <h3>
                      OBSERVAÇÕES COMPLEMENTARES: (ex: Informações sobre
                      laboratório próprios e/ou terceirizados, as respectivas
                      análises laboratoriais; lavanderia- própria ou
                      terceirizada )
                    </h3>
                    <div class="form-group required">
                      <textarea
                        class="form-control"
                        name="observacoes"
                        v-model="formulario.observacoes"
                      ></textarea>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer" v-if="show && formulario !== null">
        <div class="form-steps-vue">
          <div class="steps-actions">
            <a
              href="#"
              @click="changeStep($event, -1)"
              :class="{ 'steps-control': true, disabled: !allowPrev }"
            >Anterior</a>
            <a href="#" @click="changeStep($event, +1)" :class="{ 'steps-control': true }">
              {{
              activeTab === tabsCount - 1
              ? isReadonly
              ? "Fechar"
              : "Concluir"
              : "Próximo"
              }}
            </a>
          </div>
        </div>
      </div>
    </modal-component>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      required: true
    },
    show: {
      required: true
    },
    categorias: {
      required: true
    },
    unidadesMedida: {
      required: true
    },
    areas: {
      required: true
    },
    isReadonly: {
      required: true
    }
  },
  data: () => ({
    activeTab: 0,
    formulario: null,
    areaId: null,
    instalacoes: [],
    temperatura: ""
  }),
  watch: {
    areaId: function(newVal, oldVal) {
      if (newVal !== oldVal && newVal) {
        axios
          .get(`/sie/area/get-instalacoes/cod/${newVal}`)
          .then(response => response.data)
          .then(data => {
            this.instalacoes = data;

            setTimeout(() => {
              if (this.$refs.addItemTableInstalacoesIndustriais) {
                this.$refs.addItemTableInstalacoesIndustriais.adjustItemsList();
              }
            }, 0);
          });
      }
    },
    value: function(newVal, oldVal) {
      this.activeTab = 0;
      this.formulario = newVal;
      if (newVal) {
        this.areaId = newVal.area.cod_area;
        setTimeout(() => {
          this.changeActive();
        }, 0);
      }
    },
    formulario: {
      handler(newVal, oldVal) {
        this.$emit("change", newVal);
      },
      deep: true
    }
  },
  computed: {
    allowPrev() {
      return this.activeTab > 0;
    },
    allowedCategories() {
      return this.categorias.filter(item => item.cod_area == this.areaId);
    },
    tabsCount() {
      return this.$el.querySelectorAll(".tabs .tab").length;
    }
  },
  methods: {
    changeStep(ev, op) {
      ev.preventDefault();
      ev.stopPropagation();
      if (op < 0 && this.activeTab == 0) return;
      else if (op < 0) {
        this.activeTab += op;
        this.changeActive();
        return;
      }

      let hasError = false;
      let focusSeted = false;
      this.$el
        .querySelector(".container.active")
        .querySelectorAll(".form-group.required")
        .forEach(node => {
          const formControl = node.querySelector(".form-control");
          if (!formControl.value) {
            node.classList.add("error");
            hasError = true;

            if (!focusSeted) {
              formControl.focus();
              focusSeted = true;
            }
          } else {
            node.classList.remove("error");
          }
        });

      // Check if required checkbox are checked
      this.$el
        .querySelector(".container.active")
        .querySelectorAll(".form-check.required")
        .forEach(node => {
          const checkInput = node.querySelector(".form-check-input");
          if (!checkInput.checked) {
            node.classList.add("error");
            hasError = true;

            if (!focusSeted) {
              checkInput.focus();
              focusSeted = true;
            }
          } else {
            node.classList.remove("error");
          }
        });

      if (!hasError && op > 0 && this.activeTab == this.tabsCount - 1) {
        // Salvando
        this.onSave();
      } else if (!hasError) {
        this.activeTab += op;
        this.changeActive();
      }
    },
    onCloseModal(ev) {
      this.$emit("onClose", false);
    },
    onCloseButtonClick() {
      alert('Atenção! Ao fechar o formulario MTSE, os dados alterados não serão salvos. Por favor clique em SALVAR no final da página.');
      this.onCloseModal();
    },
    onTabClick(ev) {
      if (this.isReadonly) {
        const tab = Array.from(ev.target.classList).find(el =>
          el.includes("tab-")
        );
        if (tab) {
          const tabIndex = parseInt(tab.replace("tab-", ""));
          this.activeTab = tabIndex;
          this.changeActive();
        }
      }
    },
    changeActive() {
      try {
        this.$el.querySelectorAll(`.tabs .tab`).forEach(node => {
          node.classList.remove("active");
        });
        this.$el.querySelectorAll(`.content .container`).forEach(node => {
          node.classList.remove("active");
        });
        this.$el
          .querySelector(`.tabs .tab.tab-${this.activeTab}`)
          .classList.add("active");
        this.$el
          .querySelector(`.content .container.content-${this.activeTab}`)
          .classList.add("active");

        this.$el.querySelector(".modal-content").scrollTop = 0;
      } catch (e) {
        console.log(e);
      }
    },
    onChangeCategorias(list) {
      this.formulario.capacidade_maxima_op_list = list;
      if (list.length) {
        const categoria = this.categorias.find(
          item => item.cod_categoria == list[0].cod_categoria
        );
        this.areaId = categoria.cod_area;
        this.formulario.area = this.areas.find(
          item => item.cod_area == categoria.cod_area
        );
      } else {
        this.areaId = null;
      }
    },
    onSave() {
      this.formulario.saved = true;
      this.onCloseModal();
      alert('Atenção! Ao concluir o formulario MTSE, os dados alterados não serão salvos. Por favor clique em SALVAR no final da página.');
    }
  }
};
</script>
<style lang="scss" scoped>
.steps {
  .tabs {
    .tab {
      font-size: 11px;
      padding: 4px 6px;
      max-width: 99px;
      text-transform: uppercase;
    }
  }

  .actions {
    .steps-control {
      margin: 0 6px;
    }
  }
}

/deep/ .sida-modal {
  max-width: 900px;
}
</style>
